<div
  class="ss-select"
  [class.ss-select--open]="isOpen"
  [class.ss-select--disabled]="disabled"
  #rootEl>
  @if (isOpen) {
    <div class="ss-select__backdrop" (click)="closeDropdown()"></div>
  }

  <div
    class="ss-select__input"
    [class.ss-select__input--error]="hasError"
    (click)="toggleDropdown()">
    @if (value) {
      <span class="ss-select__selected-text">{{ value.label }}</span>
    } @else {
      <span class="ss-select__placeholder">{{ placeholder }}</span>
    }

    <svg class="ss-select__arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 10l5 5 5-5z" fill="#71717A"/>
    </svg>
  </div>

  @if (isOpen) {
    <div class="ss-select__dropdown">
      <div class="ss-select__search">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z" stroke="#71717A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14 14L11.1 11.1" stroke="#71717A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <input
          type="text"
          class="ss-select__search-input"
          [placeholder]="searchPlaceholder"
          [value]="searchText"
          (input)="onSearchInput($any($event.target).value)"
          (click)="$event.stopPropagation()"/>
      </div>

      <div class="ss-select__options" [class.ss-select__options--loading]="loading">
        @if (items.length > 0) {
          @for (item of items; track item.id) {
            <div
              class="ss-select__option"
              [class.ss-select__option--selected]="isSelected(item)"
              (click)="selectItem(item)">
              <span class="ss-select__option-label">{{ item.label }}</span>
            </div>
          }
        } @else if (loading) {
          <div class="ss-select__empty">{{ 'Loading…' }}</div>
        } @else {
          <div class="ss-select__empty">{{ emptyText }}</div>
        }
      </div>
    </div>
  }
</div>
